export const isAbsolute = (path: string) => /^https?:\/\//.test(path);

// In: https://example.com/path?foo=1#hash
// Out: /path?foo=1#hash
export const fullPath = (url: string) =>
  url.startsWith('/') ? url : url.replace(new URL(url).origin, '');
